export default __webpack_public_path__ + "50b1707f6a4c1dbf44b3473c3d582455.svg";